import React from "react";
import { Button, Col, Row, Typography, Form, Select, InputNumber } from "antd";
import { CloseSquareFilled, PlusOutlined } from "@ant-design/icons";
import Input from "antd/lib/input/Input";
import { COLORS } from "../../../constants";
const { Paragraph } = Typography;

const MICEFieldsSection = ({
  formFields = [{ type: "", label: "", name: "" }],
  rowFields = [{ label: "", name: "" }],
}) => {
  var nationalities = require("i18n-nationality");
  nationalities.registerLocale(require("i18n-nationality/langs/en.json"));
  const data = nationalities.getNames("en");

  const generateNationalityOptions = () => {
    let options = [];
    Object.keys(data).forEach((code) => {
      options.push({ value: data[`${code}`], label: data[`${code}`] });
    });
    return options;
  };

  return (
    <>
      <Form.List name={"miceFormList"}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }, index) => (
              <>
                <Row gutter={10} justify="start" align="start" key={key}>
                  {formFields.map((field) => {
                    return field.type === "dropdown" ? (
                      <>
                        {/* Dropdown */}
                        <Col span={8}>
                          <Paragraph style={{ marginRight: "10px" }}>
                            {field?.label}
                          </Paragraph>
                        </Col>
                        <Col span={16}>
                          <Form.Item
                            {...restField}
                            name={[name, field.name]}
                            rules={[{ required: true, message: "Required" }]}
                          >
                            <Select
                              options={field?.options || []}
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>
                      </>
                    ) : field.type === "dual" ? (
                      <>
                        {/* Dual default */}
                        <Col span={8}>
                          <Paragraph style={{ marginRight: "10px" }}>
                            {field?.label}
                          </Paragraph>
                        </Col>
                        <Col span={16}>
                          <Form.Item
                            {...restField}
                            name={[name, field.name, "exhibitors"]}
                          >
                            <InputNumber
                              placeholder="#of exhibitors"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8} />
                        <Col span={16}>
                          <Form.Item
                            {...restField}
                            name={[name, field.name, "visitors"]}
                          >
                            <InputNumber
                              placeholder="#of visitors"
                              style={{ width: "100%" }}
                            />
                          </Form.Item>
                        </Col>
                      </>
                    ) : field.type === "numeric" ? (
                      <>
                        <Col span={8}>
                          <Paragraph style={{ marginRight: "10px" }}>
                            {field?.label}
                          </Paragraph>
                        </Col>
                        <Col span={16}>
                          <Form.Item
                            {...restField}
                            name={[name, field.name]}
                            rules={[
                              {
                                required: true,
                                message: "Required!",
                              },
                            ]}
                          >
                            <InputNumber style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </>
                    ) : field.type === "default" ? (
                      <>
                        <Col span={8}>
                          <Paragraph>{field?.label}</Paragraph>
                        </Col>
                        <Col span={16}>
                          <Form.Item
                            {...restField}
                            rules={[
                              {
                                required: true,
                                message: "Required!",
                              },
                            ]}
                            name={[name, field.name]}
                          >
                            <Input style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </>
                    ) : (
                      <Row justify="start" align="end">
                        <Paragraph>No Field Type Found!</Paragraph>
                      </Row>
                    );
                  })}
                </Row>

                {/*LOCAL ATTENDEES SECTION */}

                <Row
                  gutter={10}
                  className={"row-darken"}
                  justify="center"
                  align="center"
                >
                  LOCAL ATTENDEES
                </Row>

                <Row gutter={10} style={{ margin: "0 30px 0 30px" }}>
                  {rowFields.map((fields) => (
                    <Col span={12}>
                      <Form.Item
                        label={fields?.label}
                        name={[name, "phResident", fields.name]}
                        rules={[
                          {
                            required: true,
                            message: "Required!",
                          },
                        ]}
                      >
                        <InputNumber style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  ))}
                </Row>

                <Row
                  gutter={10}
                  className={"row-darken"}
                  justify="center"
                  align="center"
                >
                  FOREIGN ATTENDEES
                </Row>

                <Form.List name={[name, "nonPhResident"]}>
                  {(fields, action) => (
                    <>
                      {fields.map(({ key, name, ...restField }, _index) => (
                        <Row gutter={10} key={key}>
                          <Col span={10}>
                            <Paragraph>Nationality</Paragraph>
                            <Form.Item
                              {...restField}
                              name={[name, "nationality"]}
                            >
                              <Select
                                options={generateNationalityOptions()}
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={6}>
                            <Paragraph>Male</Paragraph>
                            <Form.Item
                              rules={[
                                {
                                  required: true,
                                  message: "Required!",
                                },
                              ]}
                              {...restField}
                              name={[name, "male"]}
                            >
                              <InputNumber style={{ width: "100%" }} />
                            </Form.Item>
                          </Col>

                          <Col span={6}>
                            <Paragraph>Female</Paragraph>
                            <Form.Item
                              rules={[
                                {
                                  required: true,
                                  message: "Required!",
                                },
                              ]}
                              {...restField}
                              name={[name, "female"]}
                            >
                              <InputNumber style={{ width: "100%" }} />
                            </Form.Item>
                          </Col>

                          <Col span={2}>
                            <CloseSquareFilled
                              onClick={() => action.remove(_index)}
                              style={{
                                color: COLORS.red,
                                fontSize: 25,
                                marginTop: 40,
                              }}
                            />
                          </Col>
                        </Row>
                      ))}
                      <Row
                        justify="center"
                        align="center"
                        style={{
                          borderBottom: "solid",
                          borderBottomColor: "lightgrey",
                          marginBottom: 30,
                          marginLeft: 40,
                          marginRight: 40,
                        }}
                      >
                        <Button
                          block
                          justify="center"
                          align="center"
                          style={{
                            height: "40px",
                            marginBottom: 20,
                            marginLeft: 40,
                            marginRight: 40,
                          }}
                          onClick={() => action.add()}
                          type="primary"
                          icon={<PlusOutlined />}
                        >
                          <strong> ADD</strong>
                        </Button>
                      </Row>
                      <Col span={24} style={{ marginBottom: 20 }}>
                        <center>
                          <Button
                            // block
                            danger
                            type="primary"
                            size="middle"
                            onClick={() => remove(index)}
                          >
                            Remove Record
                          </Button>
                        </center>
                        {/* <CloseCircleOutlined
                    style={{
                      color: COLORS.red,
                      fontSize: 20,
                      margin: "10px 0 10px 0",
                    }}
                    onClick={() => remove(index)}
                  /> */}
                      </Col>
                    </>
                  )}
                </Form.List>
              </>
            ))}

            <Row>
              <Button
                style={{ marginTop: 10, marginBottom: 50 }}
                block
                onClick={() => add()}
                type="primary"
                icon={<PlusOutlined />}
              >
                ADD MORE
              </Button>
            </Row>
          </>
        )}
      </Form.List>

      <Row style={{ marginBottom: 20 }}>
        <Col span={12}>
          <Button
            size="large"
            htmlType="reset"
            style={{ backgroundColor: COLORS.blue1 }}
          >
            Reset
          </Button>
        </Col>
        <Col span={12} style={{ justifyContent: "flex-end", display: "flex" }}>
          <Button
            size="large"
            htmlType="submit"
            style={{ backgroundColor: COLORS.orange }}
          >
            Save
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default MICEFieldsSection;
